<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <Navbar />
    <div class="validation-container auth-container">
      <el-card class="validation-card auth-card" shadow="always">
        <template #header>
          <div class="card-header auth-header">
            <img src="../assets/logo2.jpeg" alt="Wedoomotion" class="auth-logo" />
            <h2>Validation de compte</h2>
            <p class="auth-subtitle">Saisissez le code à 6 chiffres reçu par e-mail</p>
          </div>
        </template>

        <el-alert
          type="info"
          :closable="false"
          class="info-alert"
        >
          <p>
            Un code a été envoyé par mail à <strong>{{ userEmail }}</strong>. Vous avez 5 minutes pour le saisir.
            Si le délai est dépassé, vos données seront supprimées et vous devrez vous réinscrire.
          </p>
        </el-alert>

        <el-form label-position="top" @submit.prevent="validateUser">
          <el-form-item label="Code de validation">
            <el-input
              v-model="validationCode"
              placeholder="Entrez le code à 6 chiffres"
              maxlength="6"
              :prefix-icon="Key"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" class="full-width" @click="validateUser">
              Valider mon compte
            </el-button>
          </el-form-item>
        </el-form>

        <el-alert
          v-if="validationMessage"
          :title="validationMessage"
          :type="validationMessageColor === 'green' ? 'success' : 'error'"
          show-icon
          :closable="false"
          class="validation-alert"
        />

        <router-link v-if="showLoginButton" to="/login">
          <el-button type="success" class="full-width login-button">
            Aller sur la page de connexion
          </el-button>
        </router-link>
      </el-card>
    </div>
  </div>
</template>

<script>
import '@/styles/auth.css'
import Navbar from '@/components/Navbar.vue'
import api from '@/api';
import { Key } from '@element-plus/icons-vue'

export default {
  components: {
    Navbar,
  },

  data() {
    return {
      validationCode: '',
      validationMessage: '',
      successMessage: '',
      showLoginButton: false,
      validationMessageColor: 'red',
      userEmail: '',
    }
  },

  computed: {
    Key() {
      return Key
    },
  },

  mounted() {
    document.body.style.backgroundColor = 'rgba(21, 109, 123)'
    this.userEmail = sessionStorage.getItem('userEmail')
    sessionStorage.removeItem('userEmail')
  },

  methods: {
    async validateUser() {
      try {
        const response = await api.post(
          '/session/validate',
          {
            validationCode: this.validationCode,
          }
        )

        if (response.status === 200) {
          this.validationMessage = 'Compte validé avec succès !'
          this.validationMessageColor = 'green'
          this.showLoginButton = true
        } else {
          this.validationMessage = 'Validation failed: ' + response.data.message
          this.validationMessageColor = 'red'
          this.showLoginButton = false
        }
      } catch (error) {
        console.error('Error during user validation:', error)
        this.validationMessage = 'Code invalide ou expiré'
        this.validationMessageColor = 'red'
        this.showLoginButton = false
      }
    },
  },
}
</script>

<style scoped>
.full-width {
  width: 100%;
}

.info-alert {
  margin-bottom: 20px;
}

.validation-alert {
  margin-bottom: 16px;
}

.login-button {
  margin-top: 8px;
}
</style>
